import { SET_AUTO_NEXT, FETCH_AUTO_NEXT } from '../actions/types';

export default function reducerAutoPlayNext(state = true, action) {
    switch (action.type) {
        case FETCH_AUTO_NEXT:
        case SET_AUTO_NEXT:
            return action.payload;
        default:
            return state;
    }
}
